import moment from "moment"
import { IS_DEV_ENV } from "../../common"

export const allowOutboundDispatch = () => {
    const workshopId = localStorage.getItem('workshopId');
    return [].includes(workshopId)
}

export const isSpeedGaugeEnabled = () => {
    const workshopId = localStorage.getItem('workshopId');

    if(IS_DEV_ENV) {
        return true
    }

    return ['2273', '2172', '2322', '1962', '1514', '1757', '1892', '2559', '2388', '2781', '5677', '5842', '5986', '6045', '6044', '6388']?.includes?.(workshopId)
}

export const isNewCatalogueFlowEnabled = () => {
    if(IS_DEV_ENV){
        return true
    }
    return true;
    // const userName = localStorage.getItem('cat_full_name');
    // console.log("userName",userName)
    // //add username in lower case only
    // const allowedUserList = ['Rahul 2553827','bhupender.singh','Amarjeet Mandal']
    // if (userName === null || userName === undefined || userName === ''){
    //     return false;
    // }
    // return allowedUserList.includes(userName.toLowerCase());
}

export const isAquaPhase2Enabled = () => {
    const workshopId = localStorage.getItem('workshopId');
    return true

    if(IS_DEV_ENV)
    {
        return ['1']?.includes?.(workshopId)
    }

    return true
}

export const isAquaEnabled = (): boolean => {
    const workshopId = localStorage.getItem('workshopId');
    return true
    if(IS_DEV_ENV)
    {
        return true
    }

    return ['2273', '2172', '2322', '1962', '1514', '1757', '1892', '2559', '2388', '2781', '5677', '5842', '5986', '6045', '6044', '6388']?.includes?.(workshopId)

}

export const isManualFetchMicroCohortEnable = (workshopId: string): boolean => {

    if(IS_DEV_ENV)
    {
        return ['633']?.includes?.(workshopId)
    }

    return ['6044']?.includes?.(workshopId)

}

export const isWarrantyEnabled = (): boolean => {

    const workshopId = localStorage.getItem('workshopId');

    if(IS_DEV_ENV)
    {
        return [ '1' ]?.includes?.(workshopId)
    }

    return true

}

export const isPurchaserModuleEnabled = (): boolean => {

    if(IS_DEV_ENV)
    {
        return (localStorage?.getItem('default_entity_id') === '53' || localStorage?.getItem('default_entity_id') === '63' || localStorage?.getItem('default_entity_id') === '1' || localStorage?.getItem('default_entity_id') === '55' || localStorage?.getItem('default_entity_id') === '64' || localStorage?.getItem('default_entity_id') === '49' || localStorage?.getItem('default_entity_id') === '65')
    }

    return [
      "53",
      "63",
      "49",
      "64",
      "51",
      "65",
      "44",
      "66",
      "45",
      "67",
      "54",
      "68",
      "47",
      "69",
      "50",
      "70",
      "55",
      "71",
      "59",
      "46",
      "72",
      "57",
      "73",
      "48",
      "74",
      "75",
      "76",
      "77",
      "78",
      "79",
      "80",
      "81",
      "82",
      "83",
    ]?.includes?.(localStorage?.getItem?.("default_entity_id"));
}

export const isBudgetApprovalEnabled = (): boolean => {
    const workshopId = localStorage.getItem('workshopId');

    if(IS_DEV_ENV)
    {
        return (workshopId === '1')
    }

    return ['1', '25', '33', '56', '64', '707', '708', '709', '1187', '1367', '1368', '1369', '1370', '1371', '6391', '6654', '6679', '6634', '6704'].includes(workshopId)
}

export const getMediaTypeFromURL = (url: string): 'VIDEO'|'IMAGE'|'AUDIO' => {
    const mediaTypes = { video: [ 'mp4', '3gpp' ], image: [ 'png', 'jpeg', 'jpg', 'gif' ], audio: [ '3gp', 'aac', 'mp3' ] }

    const urlArr = url?.split?.('.')

    return mediaTypes?.video?.includes?.(urlArr?.[urlArr?.length - 1]) ? 'VIDEO' : mediaTypes?.audio?.includes?.(urlArr?.[urlArr?.length - 1]) ? 'AUDIO' : 'IMAGE'
}

export const getHoursFromDate = (date: string) => {

    return moment.utc(new Date()).diff(moment.utc(date), 'hours')

}

export const timeIn12HourClock = (date: string) => {

    return moment.utc(date).utcOffset(330).format('hh:mm a')

}

export const daysFromUTCDate = (date: string) => {

    return `${ moment.utc(new Date()).diff(moment.utc(date), 'days') }D ${ moment.utc(new Date()).diff(moment.utc(date), 'hours')%24 }hrs`

}

export const toCamelCase = (str: string) => {

    return str?.toLowerCase()?.replaceAll?.('_', ' ')?.split(' ').map(val => val.substring(0, 1).toUpperCase() + val.substring(1, val.length))?.reduce((prev, curr) => (prev + ' ' + curr))

}

export const roundTo2DecimalPlaces = (value: number) => {
    // return Math.round((value + Number.EPSILON) * 100) / 100
    return value?.toFixed?.(2)
}

export const isCloseToTop = ({ contentOffset }) => {

    return contentOffset.y < 20

}

export const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
    const paddingToBottom = 20;
    console.log(layoutMeasurement.height + contentOffset.y, contentSize.height - paddingToBottom)
    return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom;
};

export const minFormator=(minutes:number)=>{
    const days = Math.floor(minutes / 1440); 
    const hours = Math.floor((minutes % 1440) / 60); 
    const remainingMinutes = (minutes % 60).toFixed(0);
    return `${!!days ? `${days} day${days > 1 ? 's' : ''}` :''} ${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
}
export const timeDifferenceInDayHrMin=(minutes1:number, minutes2:number)=>{
    const diff = Math.abs(minutes1 - minutes2);
    const days = Math.floor(diff / 1440); 
    const hours = Math.floor((diff % 1440) / 60); 
    const minutes = Number((diff % 60).toFixed(0)); 

    let result = [];
    if (days > 0) {
        result.push(`${days} day${days > 1 ? 's' : ''}`);
    }
    if (hours > 0) {
        result.push(`${hours} hour${hours > 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
        result.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
    }

    return result.length > 0 ? result.join(', ') : '0 minutes';
}

export const snakeToTitleCase = (snakeStr: string) => {
  if (!snakeStr || typeof snakeStr !== 'string') {
    return '';
  }
  
  return snakeStr
    .toLowerCase()
    .split('_')
    .filter(word => word.length > 0)  // Remove empty strings from multiple underscores
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
